import { ReviewSubjectType } from "@/api/cle-api";
import { AccordionFilterItem } from "@/components/accordion/Accordion";
import InputCheckbox from "@/components/formcontrols/InputCheckbox";
import { reviewSubjectTypeOptions } from "../utils/reviewSubjectType";

interface ReviewThreadSubjectTypeFilterProps {
  subjectTypes: ReviewSubjectType[];
  onSubjectTypeToggle: (
    subjectType: ReviewSubjectType,
    checked: boolean,
  ) => void;
}

export default function ReviewThreadSubjectTypeFilter({
  subjectTypes,
  onSubjectTypeToggle,
}: ReviewThreadSubjectTypeFilterProps) {
  return (
    <AccordionFilterItem
      title="Emnetype"
      value="review-thread-subject-type"
      isActive={subjectTypes.length > 0}
    >
      <div className="d-flex flex-column gap-2">
        {reviewSubjectTypeOptions.map((option) => (
          <InputCheckbox
            key={option.value}
            id={`review-thread-subject-type-${option.value}`}
            label={option.label}
            checked={subjectTypes.includes(option.value)}
            onChange={(event) =>
              onSubjectTypeToggle(option.value, event.target.checked)
            }
          />
        ))}
      </div>
    </AccordionFilterItem>
  );
}
